import { useRef, useEffect } from 'react'
import { Button } from '@/atoms/Button'
import { Image } from '@/atoms/Image'
import { ParagraphMD, ParagraphSM } from '@/atoms/Text'
import { logger } from '@/utils/logging'
import { GTitleLG, GTitleXXL } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import { useYoungWashingtonTickets } from '../hooks/useYoungWashingtonTickets'

export default function BehindTheCamera() {
  const videoRef = useRef<HTMLVideoElement>(null)
  const { handleBuyTicketsClick, ctaText } = useYoungWashingtonTickets()

  useEffect(() => {
    const video = videoRef.current
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && video) {
            video.play().catch(() => {
              logger().error('autoplay was prevented')
            })
          } else if (video) {
            video.pause()
          }
        })
      },
      { threshold: 0.4 },
    )

    if (video) {
      observer.observe(video)
    }

    return () => {
      if (video) {
        observer.unobserve(video)
      }
    }
  }, [])

  return (
    <section id="behind-the-camera-section" className="relative py-10 md:p-16">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[#00142C]"></div>
        <div
          className="bg-top-left absolute inset-0 mix-blend-multiply"
          style={{
            backgroundImage:
              'url(https://images.angelstudios.com/image/upload/c_limit,w_1200,q_50/v1760136582/young-washington/2da5e058c05395785d4d56011f0a66f071c05928.webp)',
            backgroundSize: 'cover',
          }}
        ></div>
      </div>
      <div className="relative mx-auto w-full justify-center px-4 text-center text-white md:w-[90vw] md:max-w-[1200px]">
        <div className="mx-auto max-w-2xl">
          <GTitleXXL className="hidden text-balance uppercase md:block">
            Exclusive Access: Behind The Camera With Jon Erwin
          </GTitleXXL>
          <GTitleLG className="text-balance uppercase md:hidden">
            Exclusive Access: Behind The Camera With Jon Erwin
          </GTitleLG>
          <ParagraphMD className={'mb-8 mt-3 hidden text-pretty !font-roboto !font-light md:block'}>
            {`Pre-order tickets to Young Washington to unlock Director Jon Erwin's Director's Diaries, his exclusive
            behind-the-scenes video series. For the first time ever, Jon is inviting audiences into the filmmaking
            process, sharing the story behind the story and the passion driving it.`}
          </ParagraphMD>
          <ParagraphSM className={'mb-8 mt-3  text-pretty !font-roboto !font-light md:hidden'}>
            {`Pre-order tickets to Young Washington to unlock Director Jon Erwin's Director's Diaries, his exclusive
            behind-the-scenes video series. For the first time ever, Jon is inviting audiences into the filmmaking
            process, sharing the story behind the story and the passion driving it.`}
          </ParagraphSM>
        </div>
        <div className="mx-auto mb-8 max-w-2xl">
          <div className="aspect-h-9 aspect-w-16 relative">
            <Image
              src="v1760136293/young-washington/Still_2025-10-10_141730_1.3.1"
              alt="John Erwin"
              width={672}
              height={(672 / 16) * 9}
              sizes="(max-width: 672px)"
              className="rounded-3xl object-cover"
            />
          </div>
        </div>

        <Button
          variant={'white'}
          outline={true}
          size={'md'}
          className={'mx-auto border-2 !font-roboto md:w-fit'}
          onClick={() => handleBuyTicketsClick('behind-the-camera')}
        >
          {ctaText}
        </Button>
      </div>
    </section>
  )
}
